/** client/src/lib/changelog-view.ts - copy constants and local-date grouping for /changelog. */
import type { ChangelogApiEntry } from "@/lib/api/changelog";
import { formatDateOnly, safeParseDate } from "@/lib/format-timestamp";

export const CHANGELOG_PATH = "/changelog";
export const CHANGELOG_TITLE = "What's new";

export interface ChangelogDay {
  key: string;
  heading: string;
  entries: ChangelogApiEntry[];
}

const pad = (n: number) => String(n).padStart(2, "0");

/** Rule 13: the server stores UTC; the day a viewer sees is THEIR local day. Input order is kept (newest first). */
export function groupByLocalDay(entries: readonly ChangelogApiEntry[]): ChangelogDay[] {
  const days: ChangelogDay[] = [];
  for (const entry of entries) {
    const date = safeParseDate(entry.firstLiveAt);
    if (!date) continue;
    const key = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    const last = days[days.length - 1];
    if (last && last.key === key) last.entries.push(entry);
    else days.push({ key, heading: formatDateOnly(date), entries: [entry] });
  }
  return days;
}
